<template>
  <v-container
    id="Jobs"
    fluid
    tag="section"
  >
    <v-card
      class="mx-1 px-1 py-4"
      flat
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-btn
              @click="doGetJobBatch"
            >
              Refresh
            </v-btn>
          </v-col>
          <v-col cols="12">
            <base-sq-card
              title="Summary"
            >
              <v-container>
                <v-row>
                  <v-col cols="6">
                    Job Name:
                  </v-col>
                  <v-col cols="6">
                    {{ jobBatch.job_name }}
                  </v-col>
                  <v-col cols="6">
                    Display Text:
                  </v-col>
                  <v-col cols="6">
                    {{ jobBatch.display_text }}
                  </v-col>
                  <v-col cols="6">
                    Status:
                  </v-col>
                  <v-col cols="6">
                    {{ jobBatch.status }}
                  </v-col>
                  <v-col cols="6">
                    Started At:
                  </v-col>
                  <v-col cols="6">
                    {{ formatEpoch(jobBatch.started_at, 'YYYY-MM-DD HH:mm:ss') }}
                  </v-col>
                  <v-col cols="6">
                    Finished At:
                  </v-col>
                  <v-col cols="6">
                    {{ formatEpoch(jobBatch.finished_at, 'YYYY-MM-DD HH:mm:ss') }}
                  </v-col>
                </v-row>
              </v-container>
            </base-sq-card>
          </v-col>
          <v-col cols="12">
            <base-sq-card
              title="Inputs"
            >
              <v-list>
                <v-list-item
                  v-for="(value, key) in jobBatch.input_json"
                  :key="key"
                >
                  {{ key }}: {{ value }}
                </v-list-item>
              </v-list>
            </base-sq-card>
          </v-col>
          <v-col cols="12">
            <base-sq-card
              title="Outputs"
            >
              <v-list>
                <v-list-item
                  v-for="(value, key) in jobBatch.output_json"
                  :key="key"
                >
                  {{ key }}: {{ value }}
                </v-list-item>
              </v-list>
            </base-sq-card>
          </v-col>
          <v-col cols="12">
            <base-sq-card
              title="Files"
            >
              <v-data-table
                :headers="fileHeaders"
                :items="batchFiles"
                :items-per-page="3000"
                item-key="id"
                sort-by="started_at"
                sort-desc
                class="elevation-0"
                style="width:100%"
                height="500px"
              >
                <template v-slot:item._actions="{ item }">
                  <v-btn
                    :href="item._url"
                    target="_blank"
                  >
                    GO
                  </v-btn>
                </template>
              </v-data-table>
            </base-sq-card>
          </v-col>
        </v-row>
      </v-container>
      <v-overlay :value="overlayDisplay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </v-container>
</template>

<script>
  import JobBatchService from '../../../services/job-batch.service'
  import basicMixin from '../../../mixins/basic'

  export default {
    name: 'JobsIndex',
    mixins: [basicMixin],

    data () {
      return {
        page: 1,
        rowkey: '',
        jobBatch: {},
        filter: {},
        sortBy: 'created_at',
        batchFiles: [
        ],
        fileHeaders: [
          {
            text: 'Action',
            align: 'start',
            sortable: true,
            groupable: false,
            value: '_actions',
          },
          {
            text: 'rowkey',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'rowkey',
          },
          {
            text: 'Display',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'display_text',
          },
          {
            text: 'status',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'status',
          },
        ],
        overlayDisplay: false,
        itemsPerPageArray: [50, 100, 250, 500, 1000],
      }
    },
    computed: {
    },
    async created () {
      console.log('page loaded')
      console.log(this.$route)
      if (this.$route && this.$route.query) {
        const { rowkey } = this.$route.query
        this.rowkey = rowkey
      }
      // if (this.$route.params.account) {
      //   this.selectedAccount = this.$route.params.account
      // } else if (this.$route.params.key) {
      //   const payload = {
      //     key: this.$route.params.key,
      //     params: this.$route.query,
      //   }
      //   this.selectedAccount = await this.getAccount(payload)
      // }
      this.doGetJobBatch()
    },
    mounted () {
    },
    methods: {
      async doGetJobBatch () {
        this.overlayDisplay = true
        try {
          const { data } = await JobBatchService.get(this.rowkey)
          this.jobBatch = data
          this.batchFiles = data._metafiles
          console.log(data)
          this.overlayDisplay = false
        } catch (e) {
          this.overlayDisplay = false
          console.log(e)
        }
        this.overlayDisplay = false
      },
      nextPage () {
        if (this.page + 1 <= this.numberOfPages) this.page += 1
      },
      formerPage () {
        if (this.page - 1 >= 1) this.page -= 1
      },
      updateItemsPerPage (number) {
        this.itemsPerPage = number
      },
    },
  }
</script>
